/* eslint-disable max-len */
import getData from 'sfcookieconsent/src/functions/getData';

export default {
    translationInfo: 'en_us',
    translationName: 'Deutsch',
    enableSFCookieConsent: false,
    headlineText: 'This website uses cookies',
    sublineText: 'Our website uses cookies, so we can optimize the users experience and add continual improvements.',
    submitButtonText: 'Confirm my choices',
    submitAllButtonText: 'Accept all',
    escButtonText: 'Abort',
    consentTypes: {
        marketing: {
            label: 'Marketing',
            title: 'Marketing cookies',
            text: 'Marketing cookies are used by third party providers or publishers to display personalised advertising. They follow visitors on websites to display ads that are relevant and appealing for the individual users.',
        },
        necessary: {
            label: 'Necessary',
            title: 'Necessary Cookies',
            text: 'Necessary cookies help to make a website usable by enabling functions such as page navigation and to access secure areas of the website. The website will not function properly without these cookies.',
        },
        preferences: {
            label: 'Präferenzen',
            title: 'Präferenz-Cookies',
            text: 'Präferenz-Cookies ermöglichen einer Webseite sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie sich befinden.',
        },
        statistics: {
            label: 'Statistics',
            title: 'Statistics Cookies',
            text: 'Statistics cookies help website owners understand how visitors interact with websites by collecting and reporting information anonymously.',
        },
    },
    showDetailsText: 'Show details',
    hideDetailsText: 'Hide details',
    moreInfoPreText: 'Further information on cookies can be found in our',
    moreInfoLinkText: '<span class="underline">Privacy Statement</span>&nbsp;and&nbsp;<a href="/cookie-notice" class="main-header main-header--overlaying"><span class="underline">Cookie Policy</span></a>',
    moreInfoLinkHref: '/privacy-notice',
    detailContainer: 'We use cookies to allow you to use our website in the best possible way and to improve our communication with you. Set your personal preference here:',
    scriptSettings: {
        statistics: {
            gtm: {
                enabled: true,
                key: getData('header', 'data-sfcc-gtm-key'),
                authKey: getData('header', 'data-sfcc-gtm-auth'),
                preview: getData('header', 'data-sfcc-gtm-preview'),
                gtm_cookies_win: getData('header', 'data-gtm_cookies_win'),
            },
        },
    },
};
